<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="27" height="14.172" viewBox="0 0 27 14.172">
    <path
        d="M27.258,32.792a.749.749,0,0,0-1.249-.829,9.865,9.865,0,0,1-3.481,2.817,23.011,23.011,0,0,0-1.509-7.631,5.008,5.008,0,0,0-4.682-3.183h-4.91a5.008,5.008,0,0,0-4.682,3.183A23.21,23.21,0,0,0,5.237,34.79a9.788,9.788,0,0,1-3.475-2.822A.753.753,0,0,0,.508,32.8c5.6,7.567,22.367,6.648,26.751-.011ZM6.725,35.459A21.989,21.989,0,0,1,8.138,27.7a3.514,3.514,0,0,1,3.284-2.237h4.91A3.513,3.513,0,0,1,19.616,27.7a21.832,21.832,0,0,1,1.414,7.748c-3.858,1.584-10.522,1.53-14.305.011Z"
        transform="translate(-0.383 -23.965)"></path>
  </svg>
</template>
<script setup lang="ts">
</script>